export function createVsLoadingEffect({ vs, getMotivationalPhrase }) {
  let intervalId = null;

  function start() {
    vs.loading({
      type: "sound",
      background: "rgba(255, 255, 255, 1)",
      text: getMotivationalPhrase(),
    });

    intervalId = setInterval(() => {
      const prev = document.getElementsByClassName("con-vs-loading")[0];
      if (!prev) return;

      prev.classList.add("fade-out");
      setTimeout(() => prev.remove(), 500);

      vs.loading({
        type: "sound",
        background: "rgba(255, 255, 255, 1)",
        text: getMotivationalPhrase(),
      });
    }, 5000);
  }

  function stop() {
    if (intervalId) clearInterval(intervalId);
    intervalId = null;
    vs.loading.close();
  }

  return { start, stop };
}